import { IconButton } from '@mui/material';
import ShareIcon from '@mui/icons-material/Share';
import { useAnalytics } from '../firebase/firebase';

export function ShareButton() {
    const { track } = useAnalytics();
    const handleShare = async () => {
        try {
            await navigator.share({
                title: document.title,
                url: window.location.href,
            });
        }
        catch (err) {
            console.error('Share cancelled or failed:', err);
        }
        track("share", { title: document.title, url: window.location.href })
    };

    return (
        navigator.canShare && navigator.canShare({ url: 'https://questionsalad.xyz' })
            ?
            <IconButton
                onClick={handleShare}
                title="share"
                sx={{
                    mr: 2,
                    border: 'none !important',
                }}
                color="primary"
            >
                <ShareIcon />
            </IconButton>
            :
            <></>
    );
}
